import React from 'react';
import './Dashboard.css';

const MasterDashboard = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Dashboard Master</h1>
        <div className="date-filter">
          <select>
            <option>Últimos 7 dias</option>
            <option>Últimos 30 dias</option>
            <option>Este mês</option>
            <option>Este ano</option>
          </select>
        </div>
      </div>
      
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Processos Totais</h3>
          <div className="stat-value">237</div>
          <div className="stat-trend up">+12% desde o último período</div>
        </div>
        
        <div className="stat-card">
          <h3>Clientes Ativos</h3>
          <div className="stat-value">156</div>
          <div className="stat-trend up">+8% desde o último período</div>
        </div>
        
        <div className="stat-card">
          <h3>Faturamento</h3>
          <div className="stat-value">R$ 425.680</div>
          <div className="stat-trend up">+15% desde o último período</div>
        </div>
        
        <div className="stat-card">
          <h3>Processos Pendentes</h3>
          <div className="stat-value">42</div>
          <div className="stat-trend down">-5% desde o último período</div>
        </div>
      </div>
      
      <div className="dashboard-row">
        <div className="dashboard-column">
          <div className="dashboard-card">
            <h3>Desempenho por Departamento</h3>
            <div className="chart-placeholder">
              [Gráfico de barras aqui]
            </div>
          </div>
        </div>
        
        <div className="dashboard-column">
          <div className="dashboard-card">
            <h3>Projeção de Faturamento</h3>
            <div className="chart-placeholder">
              [Gráfico de linha aqui]
            </div>
          </div>
        </div>
      </div>
      
      <div className="dashboard-card">
        <div className="card-header">
          <h3>Atividade Recente da Equipe</h3>
          <button>Ver Todos</button>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>Colaborador</th>
              <th>Processos</th>
              <th>Clientes</th>
              <th>Taxa de Sucesso</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Ana Silva</td>
              <td>28</td>
              <td>15</td>
              <td>92%</td>
              <td><span className="status-badge success">Ótimo</span></td>
            </tr>
            <tr>
              <td>Carlos Mendes</td>
              <td>24</td>
              <td>18</td>
              <td>88%</td>
              <td><span className="status-badge success">Ótimo</span></td>
            </tr>
            <tr>
              <td>Lucia Ferreira</td>
              <td>19</td>
              <td>12</td>
              <td>84%</td>
              <td><span className="status-badge good">Bom</span></td>
            </tr>
            <tr>
              <td>Paulo Santos</td>
              <td>15</td>
              <td>10</td>
              <td>73%</td>
              <td><span className="status-badge warning">Regular</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MasterDashboard;